import { RootState } from 'rootReducer';

export const selectPaymentRedirectTo = (state: RootState) =>
  state._resources.payment.paymentResult?.redirect_to;

export const selectPaymentAlertLevel = (state: RootState) =>
  state._resources.payment.paymentResult?.alert_level;

export const selectErrorCount = (state: RootState) => state._resources.payment.errorCount;
